// ClientSelectorModal.tsx
import { FunctionComponent } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    VStack,
    InputGroup,
    InputLeftElement,
    Input,
    Icon,
    Text,
    Card,
    CardBody,
    Badge,
    HStack,
    Box,
} from "@chakra-ui/react";
import { IconSelector, IconSearch, IconBuilding } from "@tabler/icons-react";
import { Client } from "../../api";

interface ClientSelectorModalProps {
    isOpen: boolean;
    onClose: () => void;
    searchTerm: string;
    setSearchTerm: (value: string) => void;
    filteredClients: Array<Client>;
    clientId: string;
    handleClientSelect: (selectedClientId: string) => void;
}

export const ClientSelectorModal: FunctionComponent<ClientSelectorModalProps> = ({
    isOpen,
    onClose,
    searchTerm,
    setSearchTerm,
    filteredClients,
    clientId,
    handleClientSelect,
}) => (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent>
            <ModalHeader>
                <HStack spacing={2}>
                    <Icon as={IconSelector} color="blue.500" />
                    <Text>Switch Client Portal</Text>
                </HStack>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
                <VStack spacing={4} align="stretch">
                    <InputGroup>
                        <InputLeftElement>
                            <Icon as={IconSearch} color="gray.400" />
                        </InputLeftElement>
                        <Input placeholder="Search clients by name or code..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
                    </InputGroup>

                    <VStack spacing={2} align="stretch" maxH="400px" overflowY="auto">
                        {filteredClients.length === 0 ? (
                            <Text color="gray.500" textAlign="center" py={4}>
                                No clients found matching your search
                            </Text>
                        ) : (
                            filteredClients.map(clientItem => (
                                <Card
                                    key={clientItem.id}
                                    cursor="pointer"
                                    onClick={() => handleClientSelect(clientItem.id)}
                                    bg={clientItem.id === clientId ? "gray.400" : "default"}
                                    borderColor={clientItem.id === clientId ? "blue.200" : "gray.200"}
                                    _hover={{
                                        bg: clientItem.id === clientId ? "blue.100" : "gray.400",
                                        transform: "translateY(-1px)",
                                        shadow: "md",
                                    }}
                                    transition="all 0.2s"
                                >
                                    <CardBody py={3}>
                                        <HStack justify="space-between" align="center">
                                            <HStack spacing={3}>
                                                <Icon as={IconBuilding} color="blue.500" />
                                                <Box>
                                                    <Text fontWeight={clientItem.id === clientId ? "semibold" : "medium"}>{clientItem.name}</Text>
                                                    {clientItem.agressoCode && (
                                                        <Text fontSize="sm" color="gray.600">
                                                            Code: {clientItem.agressoCode}
                                                        </Text>
                                                    )}
                                                </Box>
                                            </HStack>
                                            {clientItem.id === clientId && (
                                                <Badge colorScheme="blue" variant="subtle">
                                                    Current
                                                </Badge>
                                            )}
                                        </HStack>
                                    </CardBody>
                                </Card>
                            ))
                        )}
                    </VStack>
                </VStack>
            </ModalBody>
        </ModalContent>
    </Modal>
);
